export default (function(arr) {
  arr.forEach(item => {
    if (!item.hasOwnProperty('append')) {
      Object.defineProperty(item, 'append', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append(...args: HTMLElement[]) {
          const argArr = args.slice()
          const docFrag = document.createDocumentFragment()

          argArr.forEach(function(argItem) {
            const isNode = argItem instanceof Node
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)))
          })

          this.appendChild(docFrag)
        },
      })
    }
    if (!item.hasOwnProperty('remove')) {
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this)
        },
      })
    }
  })
})([Element.prototype, Document.prototype, DocumentFragment.prototype])

Promise.allSettled =
  Promise.allSettled ||
  ((promises: Promise<unknown>[]) =>
    Promise.all(
      promises.map(p =>
        p
          .then(value => ({
            status: 'fulfilled',
            value,
          }))
          .catch(reason => ({
            status: 'rejected',
            reason,
          }))
      )
    ))
